import { type ComponentProps, type ReactElement } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

/** Placeholder for the PLP Supply Chain block while deferred data resolves (text-only band; image is optional on the block). */
export function SupplyChainSkeleton({ className, ...props }: ComponentProps<'section'>): ReactElement {
    const { t } = useTranslation('supplyChain');
    return (
        <section
            className={cn(className)}
            data-component="supply-chain-skeleton"
            aria-busy
            aria-label={t('loadingAriaLabel')}
            {...props}>
            <div className="bg-neutral-white py-8 lg:py-20 grid-global gap-y-6 lg:gap-y-0">
                <div className="flex flex-col gap-6 justify-center items-center col-span-6 lg:col-start-4 lg:col-end-10">
                    <div className="flex flex-col gap-2">
                        <Skeleton className="h-4 w-28" />
                        <Skeleton className="h-9 w-full max-w-lg" />
                    </div>
                    <div className="flex flex-col gap-3">
                        <Skeleton className="h-4 w-full" />
                        <Skeleton className="h-4 w-full" />
                        <Skeleton className="h-4 w-[90%]" />
                    </div>
                    <Skeleton className="h-10 w-44" />
                </div>
            </div>
        </section>
    );
}
